import { useTranslation } from "react-i18next";

import { FaPlus } from "react-icons/fa6";
import PropTypes from "prop-types";

const InsuranceHeader = ({ onCreateInsurance, total = 0 }) => {
    const { t } = useTranslation(["insurance"]);

    return (
        <>
            <div className="my-4 flex flex-row gap-4 sm:my-5">
                <div className="min-w-0 flex-1 text-lg font-bold sm:text-[1.2rem]">
                    {t("insurance")} <span className="text-[#5d5dff]">({total})</span>
                </div>
                <div className="hidden">
                    <button
                        type="button"
                        className="p-1 px-4 rounded-full outline-none w-[15rem] bg-white text-[#5d5dff] flex justify-center items-center gap-2"
                        onClick={onCreateInsurance}
                        onKeyUp={(e) => {
                            if (e.key === "Enter") {
                                onCreateInsurance();
                            }
                        }}>
                        <FaPlus />
                        {t("createNewInsurance")}
                    </button>
                </div>
            </div>
        </>
    );
};

InsuranceHeader.propTypes = {
    onCreateInsurance: PropTypes.func.isRequired,
    total: PropTypes.number,
};

export default InsuranceHeader;
